import _extends from "@babel/runtime/helpers/esm/extends";

var _path;

import React, { forwardRef } from 'react';
import SvgIcon from '../SvgIcon';
var IconInsertLink = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var rest = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, rest, {
    ref: ref
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
  })));
});
IconInsertLink.displayName = 'IconInsertLink';
export default IconInsertLink;